import(/* webpackMode: "eager", webpackExports: ["Games"] */ "/home/nexts/lm-master-front/src/flat-pages/games/index.tsx");
